module.exports = __webpack_public_path__ + "static/media/Sarah Cheng.bda891c3.JPG";